/*
 * Copyright (c) 2025 NoorWays. All rights reserved.
 * Licensed under the terms specified in the LICENSE.txt file.
 */

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@vueuse/head'

import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { useAuthentication } from '@/authentication/AuthenticationManager'
import { useAppStore } from '@/stores/app'

// Import global styles
import '@/assets/styles/main.scss'

function bootstrap() {
  const app = createApp(App)

  // Create and configure Pinia store
  const pinia = createPinia()

  // Create head manager for meta tags
  const head = createHead()

  // Use plugins
  app.use(pinia)
  app.use(router)
  app.use(i18n)
  app.use(head)

  // Initialize authentication
  const { initializeAuthentication } = useAuthentication()
  initializeAuthentication()

  // Initialize app store settings after i18n is set up
  const appStore = useAppStore()
  appStore.initializeLanguage() // Initialize language first to sync with i18n
  appStore.initializeTheme()

  // Mount the app
  app.mount('#app')
}

bootstrap()
